import sun from "../assets/noun_sun_193929.svg";
import moon from "../assets/noun_Full Moon_193901.svg";
import umbrella from "../assets/noun_Umbrella_193937.svg";
import snowflake from "../assets/noun_Snowflake_193923.svg";
import sleet from "../assets/noun_sleet_193915.svg";
import wind from "../assets/noun_Wind_193885.svg";
import fog from "../assets/noun_fog_193897.svg";
import cloud from "../assets/noun_Cloud_193891.svg";
import cloudyDay from "../assets/noun_cloudy day_193896.svg";
import cloudyNight from "../assets/noun_Cloudy Night_193892.svg";
import hourglass from "../assets/noun_hourglass_1403095.svg";

const icons = {
  "01d": sun,
  "01n": moon,
  "10d": umbrella,
  "10n": umbrella,
  "13d": snowflake,
  "13n": snowflake,
  "sleet": sleet,
  "wind": wind,
  "50d": fog,
  "50n": fog,
  "03d": cloud,
  "03n": cloud,
  "02d": cloudyDay,
  "02n": cloudyNight,
  "loading": hourglass
};

export default icons;
